const loadingBar = require('./ui.loadingBar');
const app = require('./app.js');
const {Template} = require('./ui.template.js');

class bookmarks extends Template{

      dataType = 'bookmark';

      init(){
          this.container = document.querySelector('#bookmarks');
          const self = this;
          this.container.querySelector('.icon-arrow-left').onclick = function(){
              self.close();
          };

          this.hadnleKeydown = this.hadnleKeydown.bind(this);
      }

      show(){
        app.webSocket.sendMessage({type:"getBookmarks"});
        loadingBar.hide();
        this.container.classList.add('show');
        setTimeout(() => {
            this.container.classList.remove('fadeInUp')
        },500)
        document.body.style.overflow = 'hidden';

        
        document.addEventListener('keydown', this.hadnleKeydown);
      }


      close(){
        this.container.classList.add('fadeOutDown');
        setTimeout(() => {
            this.container.classList.remove('show');
            this.container.classList.remove('fadeOutDown');
            this.container.classList.add('fadeInUp');
            document.body.style.overflow = '';
        },500)

        document.removeEventListener('keydown', this.hadnleKeydown);
      }

      hadnleKeydown(event){
          if(event.key == 'Escape'){
              this.close();
          }
      }

      update(views, msg){
        const filter = document.querySelector('#bookmarks .filter');
        const contents = document.querySelector('#bookmarks .bookmarks-contents');
        filter.innerHTML = '';
        contents.innerHTML = '';
        this.injectAllData(msg.data.devices, filter, document.getElementById('bookmark_filter_items'), 'bookmark-filter-item', this.filterBookmarks);
        this.injectAllData(msg.data.casts, contents, document.getElementById('bookmark_items'), 'bookmark-cast-item animate', this.playCast);
      }

      playCast(data){
        const ui = require("./ui.js");
        app.webSocket.sendMessage({type:"playCast", cast_id:data.id});
        ui.views['player'] = new imagePlayer([], data, (id) => {
            app.webSocket.sendMessage({type:"stopCast", cast_id:id});
        });
      }

      filterBookmarks(device){
        console.log('#bookmarks .device-filter[data-device-id="'+device.id+'"]')
        const filterItem = document.querySelector('#bookmarks .device-filter[data-id="'+device.id+'"]');
        if(filterItem.classList.contains('active')){
            filterItem.classList.remove('active');
            document.querySelectorAll('#bookmarks .bookmark-item[data-device-id="'+device.id+'"]').forEach((item) => {
              item.parentElement.classList.remove('fadeIn');  
              item.parentElement.classList.add('fadeOut');
            });
        }
        else{
            filterItem.classList.add('active');
            document.querySelectorAll('#bookmarks .bookmark-item[data-device-id="'+device.id+'"]').forEach((item) => {
              item.parentElement.classList.remove('fadeOut');  
              item.parentElement.classList.add('fadeIn');
            });
        }
      }


}

module.exports = bookmarks;